import useRequest from '@space-shell/common/hooks/useRequest'
import type {
  CreateCommunityPermission,
  CreateCommunityPermissionArgs
} from '@space-shell/common/services/communities'
import { CommunitiesEndpoints, CommunitiesService } from '@space-shell/common/services/communities'

export const useGetCreateCommunityPermission = ({ featureName }: CreateCommunityPermissionArgs) => {
  const { data, isInitialLoading } = useRequest<CreateCommunityPermission>(
    [CommunitiesEndpoints.getCreateCommunityPermission(featureName)],
    () => CommunitiesService.getCreateCommunityPermission({ featureName })
  )

  return {
    ...data,
    isInitialLoading
  }
}
